import { PermissionsEnum } from '@features/access-control/dto/permissions';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getPermissionsAction } from './permissions.actions';

interface PermissionsState {
  permissions: string[];
}

const initialState: PermissionsState = {
  permissions: [],
};

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<PermissionsEnum[]>) => {
      state.permissions = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getPermissionsAction.fulfilled, (state, { payload }) => {
      state.permissions = payload;
    });
  },
});

export const { setPermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;
